import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  employeeCards: [],
  totalEmployees: null,
  employees: [],
  employee: {},
  biometrics: [],
  employeeBiometric: [],
  deviceCommands: [],
  devices: [],
}

export const mutations = {
  SET_EMPLOYEE_CARDS(state, employeeCards) {
    state.employeeCards = employeeCards
  },
  SET_TOTAL_EMPLOYEES(state, totalEmployees) {
    state.totalEmployees = totalEmployees
  },
  SET_EMPLOYEES(state, employees) {
    state.employees = employees
  },
  SET_EMPLOYEE(state, employee) {
    state.employee = employee
  },
  ADD_EMPLOYEE(state, employee) {
    state.employees.push(employee)
  },
  EDIT_EMPLOYEE(state, employee) {
    const index = state.employees.findIndex(
      (el) => el.employee_uuid === employee.employee_uuid
    )
    if (index !== -1) {
      state.employees.splice(index, 1, employee)
    }
  },
  DELETE_EMPLOYEE(state, employee_uuid) {
    const index = state.employees.findIndex(
      (el) => el.employee_uuid === employee_uuid
    )
    if (index !== -1) state.employees.splice(index, 1)
  },
  SET_BIOMETRICS(state, biometrics) {
    state.biometrics = biometrics
  },
  SET_EMPLOYEE_BIOMETRIC(state, employeeBiometric) {
    state.employeeBiometric = employeeBiometric
  },
  ADD_EMPLOYEE_BIOMETRIC(state, employeeBiometric) {
    state.employeeBiometric.push(employeeBiometric)
  },
  EDIT_EMPLOYEE_BIOMETRIC(state, employeeBiometric) {
    const index = state.employeeBiometric.findIndex(
      (el) =>
        el.biometric_property.biometric_property_code ===
        employeeBiometric.biometric_property.biometric_property_code
    )
    if (index !== -1) {
      state.employeeBiometric.splice(index, 1, employeeBiometric)
    }
  },
  DELETE_EMPLOYEE_BIOMETRIC(state, biometricPropertyCode) {
    const index = state.employeeBiometric.findIndex(
      (el) =>
        el.biometric_property.biometric_property_code === biometricPropertyCode
    )
    if (index !== -1) state.employeeBiometric.splice(index, 1)
  },
  SET_DEVICE_COMMANDS(state, deviceCommands) {
    state.deviceCommands = deviceCommands
  },
  SET_DEVICES(state, devices) {
    state.devices = devices
  },
  DELETE_EMPLOYEE_CARD(state, card_uuid) {
    const index = state.employeeCards.findIndex(
      (el) => el.card_uuid === card_uuid
    )
    if (index !== -1) state.employeeCards.splice(index, 1)
  },
  ASSIGNMENT_EMPLOYEE_CARD(state, card) {
    const index = state.employeeCards.findIndex(
      (el) => el.card_uuid === card.card_uuid
    )
    if (index === -1) state.employeeCards.push(card)
  },
}

export const actions = {
  fetchEmployeeCards({ commit }, payload) {
    return ApiService.fetchEmployeeCards(payload)
      .then((res) => {
        const employeeCards = res.data.data
        commit('SET_EMPLOYEE_CARDS', employeeCards)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployeeCard({ commit }, payload) {
    return ApiService.deleteEmployeeCard(payload)
      .then(() => {
        commit('DELETE_EMPLOYEE_CARD', payload.card_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  assignmentEmployeeCard({ commit }, payload) {
    return ApiService.assignmentEmployeeCard(payload)
      .then((res) => {
        const card = res.data
        commit('ASSIGNMENT_EMPLOYEE_CARD', card)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployeePhotoIdentifier({ commit }, payload) {
    return ApiService.deleteEmployeePhotoIdentifier(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },

  fetchEmployeesAuthorized({ commit }, payload) {
    return ApiService.fetchEmployeesAuthorized(payload)
      .then((res) => {
        const { data: employees, total: totalEmployees } = res.data
        commit('SET_EMPLOYEES', employees)
        commit('SET_TOTAL_EMPLOYEES', totalEmployees)
        return employees
      })
      .catch((error) => {
        throw error
      })
  },
  importEmployeeIdentifier(_, payload) {
    return ApiService.importEmployeeIdentifier(payload)
      .then((res) => {
        const data = res.data
        return data
      })
      .catch((error) => {
        throw error
      })
  },
  importEmployeeBiometric(_, payload) {
    return ApiService.importEmployeeBiometric(payload)
      .then((res) => {
        const data = res.data
        return data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchTempEmployeeList(_, payload) {
    return ApiService.fetchTempEmployeeList(payload)
      .then((res) => {
        const response = res.data
        return response
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployees({ commit }, payload) {
    return ApiService.fetchEmployees(payload)
      .then((res) => {
        const response = res.data

        commit('SET_EMPLOYEES', response.data)
        commit('SET_TOTAL_EMPLOYEES', response.total)

        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployee({ commit }, payload) {
    return ApiService.fetchEmployee(payload)
      .then((res) => {
        const employee = res.data
        commit('SET_EMPLOYEE', employee)
        return employee
      })
      .catch((error) => {
        throw error
      })
  },
  addEmployee({ commit }, payload) {
    return ApiService.addEmployee(payload)
      .then((res) => {
        const employee = res.data
        // commit('ADD_EMPLOYEE', employee)
        return employee
      })
      .catch((error) => {
        throw error
      })
  },
  editEmployee({ commit }, payload) {
    return ApiService.editEmployee(payload)
      .then((res) => {
        const employee = res.data
        // commit('EDIT_EMPLOYEE', employee)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployee({ commit }, payload) {
    return ApiService.deleteEmployee(payload)
      .then(() => {
        commit('DELETE_EMPLOYEE', payload.employee_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteTempEmployee(_, payload) {
    return ApiService.deleteTempEmployee(payload).catch((error) => {
      throw error
    })
  },

  fetchBiometrics({ commit }, _) {
    return ApiService.fetchBiometrics()
      .then((res) => {
        const biometrics = res.data.data
        commit('SET_BIOMETRICS', biometrics)
      })
      .catch((error) => {
        throw error
      })
  },

  fetchEmployeeBiometric({ commit }, payload) {
    return ApiService.fetchEmployeeBiometric(payload)
      .then((res) => {
        const employeeBiometric = res.data.data
        commit('SET_EMPLOYEE_BIOMETRIC', employeeBiometric)
      })
      .catch((error) => {
        throw error
      })
  },
  addEmployeeBiometric({ commit }, payload) {
    return ApiService.updateEmployeeBiometric(payload)
      .then((res) => {
        const employeeBiometric = res.data
        commit('ADD_EMPLOYEE_BIOMETRIC', employeeBiometric)
        return employeeBiometric
      })
      .catch((error) => {
        throw error
      })
  },
  editEmployeeBiometric({ commit }, payload) {
    return ApiService.updateEmployeeBiometric(payload)
      .then((res) => {
        const employeeBiometric = res.data
        commit('EDIT_EMPLOYEE_BIOMETRIC', employeeBiometric)
        return employeeBiometric
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployeeBiometric({ commit }, payload) {
    return ApiService.deleteEmployeeBiometric(payload)
      .then(() => {
        const biometricPropertyCode = payload.biometric_property_code
        commit('DELETE_EMPLOYEE_BIOMETRIC', biometricPropertyCode)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchDeviceCommands({ commit }, company_uuid) {
    return ApiService.fetchDeviceCommands(company_uuid)
      .then((res) => {
        const deviceCommands = res.data.data
        commit('SET_DEVICE_COMMANDS', deviceCommands)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchDevices({ commit }, payload) {
    return ApiService.fetchDevices(payload)
      .then((res) => {
        const devices = res.data.data
        commit('SET_DEVICES', devices)
      })
      .catch((error) => {
        throw error
      })
  },
  createDeviceJob(_, payload) {
    return ApiService.createDeviceJob(payload)
      .then((res) => {
        const deviceJob = res.data
        return deviceJob
      })
      .catch((error) => {
        throw error
      })
  },
  fetchJob(_, sync_job_uuid) {
    return ApiService.fetchJob(sync_job_uuid)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },

  resetEmployeePassword(_, payload) {
    return ApiService.resetEmployeePassword(payload).catch((error) => {
      throw error
    })
  },

  editCard({ commit, dispatch }, payload) {
    return ApiService.editCard(payload)
      .then(async (res) => {
        const cardResult = res.data

        const employee = await dispatch('fetchEmployee', {
          company_uuid: payload.companyUUID,
          employee_uuid: payload.employee_uuid,
        })

        if (cardResult.employee) {
          commit('EDIT_EMPLOYEE', {
            ...employee,
            card: {
              card_type: cardResult.card_type,
              card_uuid: cardResult.card_uuid,
              serial_number: cardResult.serial_number,
            },
          })
        } else {
          commit('EDIT_EMPLOYEE', { ...employee, card: null })
        }

        return cardResult
      })
      .catch((error) => {
        throw error
      })
  },

  addEmployeeToAuthorities(_, payload) {
    return ApiService.addEmployeeToAuthorities(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },

  editEmployeeToAuthorities(_, payload) {
    return ApiService.editEmployeeToAuthorities(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },

  editEmployeeTimeAttendance(_, payload) {
    return ApiService.editEmployeeTimeAttendance(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {
  getEmployeeByUUID: (state) => (uuid) => {
    return state.employees.find((el) => el.employee_uuid === uuid)
  },
}
